import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  MtsHeader,
  MtsHeaderProductLevel,
  // MtsProductLogo,
  MtsHeaderNavigation,
  MtsHeaderButtons,
  // MtsHeaderButton,
  MtsHeaderProfile
} from '@mts-ds/components-react';
import { paths } from '../../routes/Root/paths';

import { tabs } from './data';

import Tabbar from '../Tabbar';
import HeaderProfile from './HeaderProfile';
// import HeaderBell from './HeaderBell';
import HeaderSoundEnabler from '../../components/Header/HeaderSoundEnabler';

const useStyles = makeStyles(({ spacing, getColor }) => ({
  root: {
    zIndex: 1,
    backgroundColor: getColor('constant-greyscale-0'),
    padding: spacing(0, 11),
    '--grid-m-breakpoint': 0,
    '--grid-m-margin': 0,
    '--grid-t-breakpoint': 0,
    '--grid-t-margin': 0,
    '--grid-dxs-breakpoint': 0,
    '--grid-dxs-margin': 0,
    '--grid-ds-breakpoint': 0,
    '--grid-ds-max-width': 0,
    '--grid-ds-margin': 0,
    '--grid-dm-breakpoint': 0,
    '--grid-dm-max-width': 0,
    '--grid-dm-margin': 0,
    '--grid-dl-breakpoint': 0,
    '--grid-dl-max-width': 0,
    '--grid-dl-margin': 0,
    '--grid-dxl-breakpoint': 0,
    '--grid-dxl-max-width': 0,
    '--grid-dxl-margin': 0
  },
  logo: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '2px'
  }
}));

interface IProps {
  isForbidden?: boolean;
}

const Header: FC<IProps> = ({ isForbidden }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleLogoClick = () => {
    history.push(paths.map.root);
  };

  return (
    <MtsHeader className={classes.root}>
      <MtsHeaderProductLevel>
        <div slot="logo" onClick={handleLogoClick} className={classes.logo}>
          <svg
            width="113"
            height="40"
            viewBox="0 0 113 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M32 4H0V36H32V4Z" fill="#FF0032" />
            <path
              d="M21.3184 6.43884V7.93174H24.5346V13.7724L24.5352 13.8686H26.3358V7.93174H29.5519V6.43884H21.3184Z"
              fill="white"
            />
            <path
              d="M9.73556 6.46106L7.38334 11.3449L5.0311 6.46106H2.46289V13.8457H4.26339V8.56067L6.56261 13.0256H8.20411L10.504 8.56067V13.8457H12.3045V6.46106H9.73556Z"
              fill="white"
            />
            <path
              d="M27.748 31.0758C27.7144 31.3486 27.5902 31.6021 27.3952 31.7957C27.1927 31.98 26.9438 32.1056 26.6753 32.1589C26.2829 32.2367 25.8834 32.2729 25.4835 32.267C25.0576 32.2746 24.6334 32.2124 24.2275 32.083C23.8949 31.975 23.608 31.7586 23.4127 31.4685C23.2163 31.1779 23.1195 30.7584 23.1195 30.2249V29.4684C23.1195 28.931 23.2183 28.5115 23.4127 28.2209C23.6076 27.9314 23.8937 27.7153 24.2255 27.607C24.6314 27.4776 25.0557 27.4154 25.4816 27.4231C25.8815 27.4171 26.281 27.4533 26.6734 27.5311C26.9419 27.5846 27.1907 27.7102 27.3933 27.8943C27.5882 28.088 27.7124 28.3415 27.746 28.6142H29.5479C29.5153 28.0462 29.2987 27.5042 28.9307 27.0703C28.5678 26.6712 28.0981 26.3846 27.5772 26.2444C26.8941 26.0641 26.1892 25.9797 25.4828 25.9937C24.6195 25.9937 23.8708 26.1181 23.2575 26.3628C22.6509 26.5963 22.1427 27.0309 21.8177 27.5939C21.5003 28.1391 21.3334 28.8669 21.3223 29.7589V29.8408L21.4185 29.8447H21.3223V29.9265C21.3334 30.8185 21.5003 31.5464 21.8177 32.0916C22.1427 32.6546 22.6509 33.0891 23.2575 33.3226C23.8715 33.5674 24.6209 33.6917 25.4828 33.6917C26.1892 33.706 26.8942 33.6216 27.5772 33.4411C28.0983 33.3014 28.5682 33.0146 28.9307 32.6151C29.2988 32.1812 29.5154 31.6392 29.5479 31.0712L27.748 31.0758Z"
              fill="white"
            />
            <path
              d="M43.8898 14.27V26H41.5098V14.27H43.8898ZM53.9216 21.189C53.9216 20.3163 53.6723 19.7043 53.1736 19.353C52.675 18.9903 51.944 18.809 50.9806 18.809C50.006 18.809 49.2693 18.9903 48.7706 19.353C48.272 19.7043 48.0226 20.3163 48.0226 21.189V22.243C48.0226 23.1157 48.272 23.7333 48.7706 24.096C49.2693 24.4587 50.006 24.64 50.9806 24.64C51.9553 24.64 52.6863 24.4587 53.1736 24.096C53.6723 23.7333 53.9216 23.11 53.9216 22.226V21.189ZM45.7446 21.733C45.7446 20.8943 45.858 20.1917 46.0846 19.625C46.3113 19.047 46.6456 18.5823 47.0876 18.231C47.5296 17.8797 48.0736 17.6303 48.7196 17.483C49.377 17.3243 50.1306 17.245 50.9806 17.245C51.8306 17.245 52.5786 17.3243 53.2246 17.483C53.882 17.6303 54.426 17.8797 54.8566 18.231C55.2986 18.5823 55.633 19.047 55.8596 19.625C56.0863 20.1917 56.1996 20.8943 56.1996 21.733C56.1996 22.583 56.0863 23.2913 55.8596 23.858C55.633 24.4247 55.2986 24.8837 54.8566 25.235C54.426 25.5863 53.882 25.8357 53.2246 25.983C52.5786 26.1303 51.8306 26.204 50.9806 26.204C50.1306 26.204 49.377 26.1303 48.7196 25.983C48.0736 25.8357 47.5296 25.5863 47.0876 25.235C46.6456 24.8837 46.3113 24.4247 46.0846 23.858C45.858 23.2913 45.7446 22.583 45.7446 21.733ZM55.1316 16.208V14.27H67.0996V16.208H62.3056V26H59.9256V16.208H55.1316ZM74.6193 14.27V19.013H81.5723V14.27H83.9523V26H81.5723V20.951H74.6193V26H72.2393V14.27H74.6193ZM86.447 14.27H88.827V21.172C88.827 21.784 88.9007 22.2997 89.048 22.719C89.2067 23.127 89.439 23.4557 89.745 23.705C90.051 23.943 90.4307 24.113 90.884 24.215C91.3374 24.317 91.8587 24.368 92.448 24.368C93.0374 24.368 93.5587 24.317 94.012 24.215C94.4654 24.113 94.845 23.943 95.151 23.705C95.457 23.4557 95.6837 23.127 95.831 22.719C95.9897 22.2997 96.069 21.784 96.069 21.172V14.27H98.313V21.24C98.313 22.9513 97.8257 24.2093 96.851 25.014C95.8877 25.8073 94.42 26.204 92.448 26.204C90.442 26.204 88.9404 25.8073 87.943 25.014C86.9457 24.2093 86.447 22.9513 86.447 21.24V14.27ZM108.188 14.27C109.322 14.27 110.189 14.508 110.789 14.984C111.401 15.4487 111.707 16.1627 111.707 17.126C111.707 17.7493 111.56 18.3047 111.265 18.792C110.982 19.2793 110.495 19.6307 109.803 19.846C110.574 20.0387 111.141 20.373 111.503 20.849C111.866 21.3137 112.047 21.9087 112.047 22.634C112.047 23.7333 111.736 24.572 111.112 25.15C110.5 25.7167 109.577 26 108.341 26H100.827V14.27H108.188ZM109.65 22.294C109.65 21.818 109.492 21.4497 109.174 21.189C108.857 20.917 108.375 20.781 107.729 20.781H103.173V24.385H107.729C109.01 24.385 109.65 23.8637 109.65 22.821V22.294ZM109.293 17.279C109.293 16.3497 108.721 15.885 107.576 15.885H103.173V19.234H107.576C108.154 19.234 108.585 19.1037 108.868 18.843C109.152 18.571 109.293 18.1857 109.293 17.687V17.279Z"
              fill="black"
            />
          </svg>
        </div>

        {/*<MtsProductLogo beta slot="logo" onClick={handleLogoClick} className={classes.logo}>*/}
        {/*  Safe Zone*/}
        {/*</MtsProductLogo>*/}
        {!isForbidden && (
          <>
            <MtsHeaderNavigation>
              <Tabbar tabs={tabs} startsWith />
            </MtsHeaderNavigation>
            <MtsHeaderButtons>
              {/* <MtsHeaderButton variant="notification" /> */}
              <HeaderSoundEnabler />
              {/*<HeaderBell />*/}
            </MtsHeaderButtons>
            <MtsHeaderProfile>
              <HeaderProfile />
            </MtsHeaderProfile>
          </>
        )}
      </MtsHeaderProductLevel>
    </MtsHeader>
  );
};

export default Header;
